import { Button, message } from "antd";
import { FC } from "react";
import {
  copySVG,
  facebookSVG,
  instagramSVG,
  websiteSVG,
} from "../../../assets/SVGs/SVGs";
import { FormattedMessage, useIntl } from "react-intl";

interface ChannelsProps {}

const Channels: FC<ChannelsProps> = ({}) => {
  const link = "lookfindr/noursalon-book/";
  const code = `<section id="direct-links"> 
<h2>Direct Links</h2>
<p>Provide direct links to your salon's services, staff, and promotions for a seamless client experience.</p>
</section>
<section id="channels">
<h2>Channels</h2>
<p>Explore different channels to reach your clients, whether through social media or other communication platforms.</p>
`;
  const intl = useIntl();
  return (
    <div className="py-12 px-8 bg-[#EEF0FF] space-y-8">
      <div className="space-y-3">
        <div className="space-y-3">
          <h2 className="text-2xl text-color-primary">
            {intl.formatMessage({ id: "moreOptionsTitle" })}
          </h2>
          <p className="text-[#75757E]">
            {intl.formatMessage({ id: "moreOptionsDescription" })}
          </p>
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-between gap-2 px-6 py-8 bg-white rounded shadow-full">
        <div>
          <p className="flex gap-4">
            <span>{instagramSVG}</span>
            <span className="text-color-primary text-xl">
              {intl.formatMessage({ id: "facebookInstagram" })}
            </span>
          </p>
          <p className="flex gap-4 items-center">
            <span>{facebookSVG}</span>
            <span className="text-color-sec-title w-2/3">
              {intl.formatMessage({
                id: "bookingButtonExplanation",
              })}
            </span>
          </p>
        </div>
        <div className="self-center ">
          <Button type="primary" htmlType="button" className="w-[160px]">
            {intl.formatMessage({
              id: "start_integration_now",
            })}{" "}
          </Button>
        </div>
      </div>

      <hr />
      <div className="px-6 py-8 bg-white rounded shadow-full space-y-14">
        <div>
          <div className=" flex gap-4 items-center">
            <span>{websiteSVG}</span>
            <p>
              <span className="text-color-primary text-xl">
                {intl.formatMessage({
                  id: "do_you_have_website",
                })}{" "}
              </span>
              <p className="text-color-sec-title  ">
                {" "}
                {intl.formatMessage({
                  id: "websiteDescription",
                })}{" "}
              </p>
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-9 gap-8">
          <div className="space-y-6 col-span-1 md:col-span-5 ">
            <div className="flex gap-2 items-center">
              <span className="flex items-center justify-center w-6 h-6 rounded-full  bg-[#EEF0FF] text-color-primary ">
                1
              </span>
              <p className="text-color-primary w-full font-semibold">
                {intl.formatMessage({
                  id: "add_this_code_to_your_website",
                })}{" "}
              </p>
            </div>
            <div className="bg-[#EEF0FF] px-2 py-6 relative rounded">
              <p dir="ltr" className="text-color-sec-title">
                {code}
              </p>
              <Button
                type="link"
                htmlType="button"
                onClick={() => {
                  navigator.clipboard.writeText(code);
                  message.success("تم نسخ الكود");
                }}
                className="absolute top-1 right-1"
              >
                {copySVG}
              </Button>
            </div>
          </div>
          <div className="space-y-6 col-span-1 md:col-span-4 ">
            <div className="flex gap-2 items-center">
              <span className="flex items-center justify-center w-6 h-6 rounded-full bg-[#EEF0FF] text-color-primary ">
                2
              </span>
              <p className="text-color-primary  font-semibold">
                {intl.formatMessage({
                  id: "use_this_link_for_any_button",
                })}{" "}
              </p>
            </div>
            <div className="bg-[#EEF0FF] px-2 py-6 relative rounded">
              <p dir="ltr" className="text-color-sec-title">
                {link}
              </p>
              <Button
                type="link"
                htmlType="button"
                onClick={() => {
                  navigator.clipboard.writeText(code);
                  message.success("تم نسخ الرابط");
                }}
                className="absolute top-1 right-1"
              >
                {copySVG}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Channels;
